import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/discovery/previewAlert';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* operation(action) {
  try {
    const { goalId, condition } = action?.payload || {};
    const response = yield call(
      axios.post,
      `${config.API_URL}/goals/${goalId}/alerts/preview`,
      { condition },
      { headers: getLocalUser() },
    );
    yield put(fetchSuccess(response.data?.data ?? response.data));
  } catch (error) {
    // Best-effort preview: the dialog simply hides the chart on failure,
    // matching the previous inline behavior — no global error surface.
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  // takeLatest: while the user tunes the condition, the latest pending
  // preview always wins.
  yield takeLatest(REQUEST, operation);
}
